import { Box, Button, Circle, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";
export const MenuItem = (props) => {
    const containsActive = (page) => {
        if (page.active) {
            return true;
        }
        for (let child of page.children) {
            if (containsActive(child)) {
                return true;
            }
        }
        return false;
    };
    const [expanded, setExpanded] = useState(false);
    useEffect(() => {
        if (containsActive(props.page)) {
            setExpanded(true);
        }
    }, [props.page]);
    return (React.createElement(VStack, { w: "100%", alignItems: "flex-start" },
        React.createElement(Button, { justifyContent: "flex-start", as: "a", href: props.page.href, variant: props.page.active ? "solid" : "ghost", color: "reaBlue.900", fontWeight: "normal", leftIcon: React.createElement(Box, { onClick: (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setExpanded(!expanded);
                }, w: 6 }, props.page.children.length === 0 ?
                React.createElement(Circle, { size: 1, bg: "reaBlue.900" })
                :
                    expanded ?
                        React.createElement(ChevronDownIcon, null)
                        :
                            React.createElement(ChevronRightIcon, null)) },
            React.createElement(Text, null, props.page.label)),
        React.createElement(VStack, { w: "100%", justifyContent: "flex-start", pl: 4 }, expanded && props.page.children.map(child => React.createElement(MenuItem, { key: child.id, page: child })))));
};
